<template>
  <div>
    <div v-for="(group, groupIndex) in agenda.groups" :key="`agenda-group-${groupIndex}`">
      <h5 class="session-day">{{group.date}}</h5>

      <div v-for="(session, sessionIndex) in group.sessions" :class="`card ${session.group_id}`" :key="`agenda-session-${sessionIndex}`">
        <div class="card-header agenda-group-header-wrapper">
          {{session.name}} {{session.start_at}} - {{session.end_at}}
        </div>

        <div class="">
          <form class="agenda-groups-form">
            <ul>
              <li
                v-for="(el, elIndex) in session.items"
                :key="`session-${session.id}-item-${elIndex}`"
                class="agenda-session-item"
                :class="[
                  isCapacityReached(el) ? 'capacity-reached' : '',
                  isGroupBlocked(session.group_id) ? 'block-session' : ''
                ]"
              >
                <validation-provider
                  class="session-room-checkbox-wrapper"
                  :vid="`sessions.${elIndex}.selected`"
                  v-slot="{errors}"
                >
                  <div
                    class="choice-wrapper"
                    :class="{
                      disabled: isCapacityReached(el) || isGroupBlocked(session.group_id)
                    }"
                  >
                    <event-radio
                      :class="{'is-invalid': errors && errors[0]}"
                      :label="showSessionLabel(el)"
                      v-model="session.selected"
                      :name="session.group_id"
                      :data-value="el.id"
                      :disabled="isCapacityReached(el) || isGroupBlocked(session.group_id)"
                    ></event-radio>
                  </div>
                  <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                </validation-provider>

                <p>
                  <strong>Start Date:</strong> <span class="font-weight-normal">{{el.date}}</span>
                  <strong> | Start Time:</strong> <span class="font-weight-normal">{{el.start_at}}</span>
                  <strong> | End Time:</strong> <span class="font-weight-normal">{{el.end_at}}</span>
                </p>

                <p v-if="el.presenters?.length && conference.id === 8350">
                  <strong>Speakers:</strong>
                  <i
                    v-for="(speaker, speakerIndex) in el.presenters" :key="`session-${session.id}-speaker-${speakerIndex}`"
                    class="font-weight-normal"
                  >
                    {{speaker.name}}<span v-show="(speakerIndex + 1) < el?.presenters?.length">, </span>
                  </i>
                </p>

                <p class="font-weight-normal" v-show="el.description" v-html="el.description"></p>

                <hr v-show="(elIndex + 1) < session.items?.length" />
              </li>
            </ul>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    agenda: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // Set of group_ids that should be disabled because of currently selected sessions
    disabledGroupSet() {
      const set = new Set();
      if (!this.agenda?.groups?.length) return set;

      this.agenda.groups.forEach(group => {
        group.sessions?.forEach(session => {
          if (session?.selected && Array.isArray(session?.concurrent_groups)) {
            session.concurrent_groups.forEach(gid => set.add(gid));
          }
        });
      });

      return set;
    },

    ...mapGetters("basketStore", [
      "conference",
    ]),
  },
  data() {
    return {}
  },
  methods: {
    isCapacityReached(el) {
      if (el.count_capacity && el.available_capacity <= 0) {
        return true;
      }
      return false;
    },

    isGroupBlocked(groupId) {
      return this.disabledGroupSet.has(groupId);
    },

    showSessionLabel(el) {
      let label = el.name;
      if (this.agenda.concurrent_session && el.count_capacity) {
        let helpText;
        if (el.available_capacity > 0) {
          helpText = `<span>${el.available_capacity} spots remaining</span>`;
        } else {
          helpText = `<span class="text-danger">Capacity Reached</span>`;
        }

        label = `${label} - ${helpText}`;
      }
      return label;
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group .control-label {
  font-weight: 400;
}

:deep(.app-checkbox div) {
  font-weight: 400;
}

:deep(.fv-help-block) {
  font-family: sans-serif;
  font-weight: 700;
  color: #dc3545 !important;
  font-size: 16px;
}
</style>
